import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import AddPrimarySite from '../addSite';
import RsuiSiteSelect from '../selectSite/RsuiSiteSelect';
import { noop } from '@/util';
import { IPSService } from '@/services/ipsServices';

@DialogFactory
@Component({
  components: {
    AddPrimarySite,
  },
})
export default class AddArea extends IPSDialog {
  title = '区域配置';
  width = '500px';
  $refs: {
    form: ElForm;
  };

  sgId: string;

  areaInfo: AreaListNew;

  data: AreaInfo = {
    areaId: 0, // 为0表示不能配置和删除
    areaName: '', // 区域名称
    siteId: null,
    sgId: 0,
    siteName: '',
    siteCode: '',
    mappingSiteCodes: [],
  };

  rules = {
    areaName: [{ required: true, message: '请输入区域名称', trigger: 'blur' }],
    siteName: [{ required: true, message: '请添加对应区域店', trigger: ['blur', 'change'] }],
    mappingSiteCodes: [{ required: true, message: '请添加关联门店', trigger: ['blur', 'change'] }],
  };

  // 对应区域店不能选的店铺
  siteCodeList: string[] = [];
  // 对应关联门店不能选的店铺
  siteCodeMappingList: string[] = [];

  // 对应区域店选择网点

  selectSite(code) {
    // code为0则为选择网点，为1是查看网点
    AddPrimarySite.open({
      sgId: this.data.sgId,
      inSiteCodes: [],
      outSiteCodes: this.siteCodeList,
      title: '选择网点',
      code,
    }).then((res) => {
      // 未保存的对应区域店，先将原有的siteCode删除，再将已选好的放入数组
      this.siteCodeList.splice(this.siteCodeList.indexOf(this.data.siteCode), 1);
      this.data.siteId = res.siteId;
      this.data.siteName = res.siteName;
      this.data.siteCode = res.siteCode;
      this.siteCodeList.push(this.data.siteCode);
      this.$refs.form.validate(noop);
    }, noop);
  }

  // 关联门店选择网点
  RsuiSite(e) {
    // 获取存储在缓存中的第一个门店的siteId
    const siteId = localStorage.getItem('firstSiteId');
    // 关联店铺要排除后端返回的接口查询出来的网点
    const exArr = this.siteCodeMappingList;
    new RsuiSiteSelect().openSiteSelectPick(null, siteId, exArr, this.data.mappingSiteCodes).then((res: any) => {
      const strArr = res.selected.map((v) => {
        return v.id;
      });
      // 关联店铺要回显已选择的网点
      this.data.mappingSiteCodes = strArr;
      this.$refs.form.validate(noop);
    });
    e.stopPropagation();
  }

  // 由于可能会存在多人同时编辑的情况，所以此处实时获取数据库中的数据
  getAreaInfo() {
    IPSService.areaInfo({ postParams: { areaId: this.areaInfo.areaId } }).then((res) => {
      this.data = res;
    });
  }

  // 获取不能选择的网点
  getOutSiteList() {
    const postParams = {
      sgId: +this.sgId,
    };
    if (this.areaInfo.areaId) {
      postParams['outAreaId'] = this.areaInfo.areaId;
    }
    IPSService.areaOutSiteList({
      postParams,
    }).then((res) => {
      this.siteCodeList = res.siteCodeList;
      this.siteCodeMappingList = res.siteCodeMappingList;
    });
  }

  created() {
    // 新增时不需要查询详情接口
    if (this.areaInfo.areaId) {
      this.getAreaInfo();
    }
    this.getOutSiteList();
  }

  beforeConfirm() {
    this.$refs.form.validate((result) => {
      if (result) {
        const { areaId, areaName, siteId, mappingSiteCodes, sgId } = this.data;
        const postParams = {
          areaId: areaId || 0,
          areaName,
          siteId,
          mappingSiteCodes,
          sgId: sgId || +this.sgId,
        };
        IPSService.areaSave({
          postParams,
        }).then(
          (res) => {
            this.$message.success('保存成功');
            this.$emit('result', this.data);
            this.$emit('hidden');
          },
          () => {
            this.confirmloading = false;
          },
        );
      } else {
        this.confirmloading = false;
      }
    });
  }

  onConfirm() {
    this.beforeConfirm();
  }

  // 删除对应区域店，区域店只能选择一个
  deleteItem() {
    this.data.siteId = null;
    this.data.siteName = '';
    this.data.siteCode = '';
  }
  // 删除关联门店，关联门店可以有多个

  deleteMapSiteCode(index?) {
    if (index) {
      this.data.mappingSiteCodes.splice(index, 1);
      return;
    }
    this.data.mappingSiteCodes.splice(0);
  }

  renderContent(h) {
    return (
      <div class="r-px-30 r-py-10">
        <el-form props={{ model: this.data }} rules={this.rules} label-position="top" ref="form">
          <el-form-item prop="areaName" class="r-mb-10" label="区域名称">
            <div class=" border-box r-mt--12">
              <el-input v-model={this.data.areaName}></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="siteName" class="r-mb-10" label="对应区域店">
            <div onClick={() => this.selectSite(0)} class="border-white border-radius-4 hei-16 width-100 border-box relative-position  r-pr-20 r-pl-2 cursor-pointer r-mt--8 r-mb-4 r-ml-0">
              {this.data.siteName ? (
                <el-tag v-model={this.data.siteName} class="hei-13 line-height-24 vertical-top r-mt-2" closable onClose={() => this.deleteItem()}>
                  {this.data.siteName}
                </el-tag>
              ) : (
                ''
              )}
              <i class="font-size-12 font-normal absolute right-4 text-blue-15 hei-14 line-height-28 iconfont iconshaixuan1" />
            </div>
            <p class="tip line-height-20">1）请在OMS中配置好区域店，并关联至此。请确保正确关联！</p>
            <p class="tip line-height-20">2）当顾客的地理位置在区域店的关联网点范围内，则该顾客所看到的商品价格即为该区域店所设价格。</p>
          </el-form-item>
          <el-form-item prop="mappingSiteCodes" class="r-mb-10" label="关联门店">
            <div onClick={e => this.RsuiSite(e)} class="border-white border-radius-4 hei-16 width-100 border-box relative-position  r-pr-20 r-pl-2 cursor-pointer r-mt--8 r-mb-4 r-ml-0">
              {this.data.mappingSiteCodes ? (
                this.data.mappingSiteCodes.length <= 4 ? (
                  this.data.mappingSiteCodes.map((i, index) => {
                    return (
                      <el-tag
                        v-model={this.data.mappingSiteCodes}
                        class="hei-13 line-height-24 vertical-top r-mr-4 r-mt-2"
                        closable
                        onClose={() => {
                          this.deleteMapSiteCode(index);
                        }}>
                        {i}
                      </el-tag>
                    );
                  })
                ) : (
                  <el-tag
                    v-model={this.data.mappingSiteCodes}
                    class="hei-13 line-height-24 vertical-top r-mt-2"
                    closable
                    onClose={() => {
                      this.deleteMapSiteCode();
                    }}>
                    已选择{this.data.mappingSiteCodes.length}个网点
                  </el-tag>
                )
              ) : (
                ''
              )}
              <i class="font-size-12 font-normal absolute right-4 text-blue-15 hei-14 line-height-28 iconfont iconshaixuan1" />
            </div>
            <p class="tip line-height-20">1）请配置当前区域所关联的门店列表，在获取到顾客地理位置信息后，将找到距其最近的门店反推对应的区域店，以展示价格。</p>
            <p class="tip line-height-20">2）如门店有变化，请在此及时进行增删；</p>
          </el-form-item>
        </el-form>
      </div>
    );
  }
}
